export const chain = (...funcs) => {
  let nextIndex;
  let nextArgs;

  const callNext = (...args) => {
    if (!nextArgs) nextArgs = args;
    nextIndex += 1;
    return funcs[nextIndex]?.(callNext, ...nextArgs);
  };

  return (...args) => {
    nextIndex = -1;
    nextArgs = null;

    return callNext(...args);
  };
};

export const latestCallbackTracker = () => {
  let lastCb = null;

  return (cb) => {
    lastCb = cb;

    return (...args) => {
      if (lastCb === cb) return cb(...args);
      return null;
    };
  };
};